import { useState, useEffect, useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import BlogMainStyle from '../../assets/stylesheets/blog/BlogPage.module.css';
import FamilyMain from '../../assets/img/blog/familyMain.webp';
import MarketMain from '../../assets/img/blog/marketMain.webp';
import VancouverMain from "../../assets/img/blog/vancouver-main.webp";
import LavenderMain from "../../assets/img/blog/lavender/MainLavender.webp"; 
import BloomingMain from "../../assets/img/blog/advantures/MainBlooming.webp"; 
import BestFarmMain from "../../assets/img/blog/april/MainBestFarm.webp"; 
import EasterMain from "../../assets/img/blog/easter/MainEaster.webp"; 
import BestVisitMain from "../../assets/img/blog/march/MainVisit.webp";
import MapleMain from "../../assets/img/blog/maple/MainMaple.webp";
import Main25Maple from "../../assets/img/blog/25maple/Main25MapleFarm.webp";
import FebruaryMain from "../../assets/img/blog/february/MainFebruary.webp";
import MainEvergreen from "../../assets/img/blog/evergreen/MainEvergreen.webp";
import MainChristmas from "../../assets/img/blog/christmas/MainChristmas.webp"; 
import MainQC from "../../assets/img/blog/qc/mapleSyrup03.webp"; 
import MainON from "../../assets/img/blog/on/wheeler04.webp"; 


const BlogPage = () => {
  const [searchParams] = useSearchParams();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  
  // Get selected category and search from URL params
  const selectedCategory = searchParams.get('category') || 'all';
  const search = searchParams.get('search') || '';

  // Local hardcoded entries
  const localCards = [
     {
      id: 'best-maple-syrup-farms-ontario',
      title: 'Best Maple Syrup Farms in Ontario (2026 Guide)',
      excerpt: 'Discover the best maple syrup farms to visit in Ontario in 2026! From family-friendly activities to delicious maple treats, explore the top spots for maple lovers.',
      imageUrl: MainON,
      categoryName: 'Experience',
      author: 'Farmciti',
      publishedAt: '2026-03-05',
      slug: 'best-maple-syrup-farms-ontario'
    },
      {
      id: 'best-maple-syrup-farms-quebec',
      title: 'Best Maple Syrup Farms in Quebec (2026 Guide)',
      excerpt: 'Discover the best maple syrup farms to visit in Quebec in 2026! From family-friendly activities to delicious maple treats, explore the top spots for maple lovers.',
      imageUrl: MainQC,
      categoryName: 'Experience',
      author: 'Farmciti',
      publishedAt: '2026-03-05',
      slug: 'best-maple-syrup-farms-quebec'
    },
      {
      id: 'best-christmas-markets-near-vancouver',
      title: 'Best 5 Christmas Markets near Vancouver 2025',
      excerpt: 'Discover the best Christmas markets near Vancouver in 2025! From festive lights and artisan stalls to family-friendly winter fun, explore Vancouver, North Vancouver, Victoria, and Burnaby holiday markets.',
      imageUrl: VancouverMain,
      categoryName: 'Event',
      author: 'Farmciti',
      publishedAt: '2025-11-25',
      slug: 'best-christmas-markets-near-vancouver'
    },
    {
      id: 'best-christmas-markets-near-toronto',
      title: 'Best 5 Christmas Markets near Toronto 2025',
      excerpt: 'Looking for magical holiday experiences this season? From twinkling lights to festive treats, these can’t-miss Christmas markets near Toronto are perfect for making unforgettable family memories. Cozy up, explore artisan stalls, enjoy seasonal fun, and get into the holiday spirit!',
      imageUrl: MarketMain,
      categoryName: 'Event',
      author: 'Farmcity',
      publishedAt: '2025-11-14',
      slug: 'best-christmas-markets-near-toronto'
    },
    {
      id: 'family-kids-friendly-christmas-tree-farms-ontario',
      title: 'Family & Kids-Friendly Christmas Tree Farms in Ontario',
      excerpt: 'Looking to make magical holiday memories this season? Discover the best family-friendly Christmas tree farms in Ontario, where kids can meet Santa, ride wagons and tractors, feed farm animals, and enjoy cozy campfires. These farms offer a full festival-style holiday experience that the whole family will love.',
      imageUrl: FamilyMain,
      categoryName: 'Experience',
      author: 'Farm City',
      publishedAt: '2024-11-28',
      slug: 'family-kids-friendly-christmas-tree-farms-ontario'
    },
     {
      id: 'best-lavender-farms-ontario',
      title: 'Best 5 Lavender Farms in Ontario 2025',
      excerpt: 'Discover the best lavender farms to visit in Ontario in 2025! From picturesque fields to unique experiences, explore the top spots for lavender lovers.',
      imageUrl: LavenderMain,
      categoryName: 'Travel',
      author: 'Farmciti',
      publishedAt: '2025-11-25',
      slug: 'best-lavender-farms-ontario'
    },
     {
      id: 'blooming-adventures-countryside-charm',
      title: 'Blooming Adventures & Countryside Charm in June',
      excerpt: 'June is when Ontario comes alive! Discover the top flower markets, lavender farms, and family adventures near Toronto. Explore our guide to the season\'s best blooming spots and countryside charm.',
      imageUrl: BloomingMain,
      categoryName: 'Event',
      author: 'Farmciti',
      publishedAt: '2025-11-25',
      slug: 'blooming-adventures-countryside-charm'
    },
     {
      id: 'the-best-farm-to-visit-april',
      title: 'The Best Farm to visit in April 2025',
      excerpt: 'April is the perfect time to explore Ontario\'s beautiful farms. Discover the best spots for spring blooms, family activities, and local produce. Our guide highlights must-visit farms for a memorable experience.',
      imageUrl: BestFarmMain,
      categoryName: 'Travel',
      author: 'Farmciti',
      publishedAt: '2025-04-03',
      slug: 'the-best-farm-to-visit-april'
    },
    {
      id: 'celebrate-easter-2025-at-local-farms',
      title: 'Celebrate Easter 2025 at Local Farms',
      excerpt: 'Hop into spring with our guide to the best Easter farm events in Ontario! From egg hunts and bunny meet-and-greets to wagon rides and baby animals, find the perfect farm for your family celebration this April.',
      imageUrl: EasterMain,
      categoryName: 'Event',
      author: 'Farmciti',
      publishedAt: '2025-03-20',
      slug: 'celebrate-easter-2025-at-local-farms'
    },
    {
      id: 'the-best-farm-to-visit-march',
      title: 'The Best Farm to visit in March 2025',
      excerpt: 'March signals the sweet arrival of spring! Discover the best farms to visit for maple syrup festivals, sugar bush tours, and pancake breakfasts. Enjoy the first taste of the season with family and friends.',
      imageUrl: BestVisitMain,
      categoryName: 'Travel',
      author: 'Farmciti',
      publishedAt: '2025-03-01',
      slug: 'the-best-farm-to-visit-march'
    },
    {
      id: 'celebrate-maple-syrup-festival-in-ontario-2025',
      title: 'Canada’s Favorite Celebration! Maple Syrup Festival in Ontario 2025',
      excerpt: 'Experience the taste of spring at Ontario’s finest maple syrup farms and festivals. From sugar bush tours to pancake breakfasts, discover where to celebrate the sweetest season.',
      imageUrl: MapleMain,
      categoryName: 'Event',
      author: 'Farmciti',
      publishedAt: '2025-02-11',
      slug: 'celebrate-maple-syrup-festival-in-ontario-2025'
    },
    {
      id: '25-must-visit-maple-syrup-farms-near-toronto',
      title: '25 Must-Visit Maple Syrup Farms Near Toronto',
      excerpt: 'Ontario’s sweetest season has arrived! Discover 25 of the best maple syrup farms, sugar shacks, and pancake houses near Toronto for a delicious spring adventure.',
      imageUrl: Main25Maple,
      categoryName: 'Travel',
      author: 'Farmciti',
      publishedAt: '2025-02-11',
      slug: '25-must-visit-maple-syrup-farms-near-toronto'
    },
    {
      id: 'the-best-farm-to-visit-in-feb',
      title: 'The Best Farm to visit in February 2025',
      excerpt: 'February might be chilly, but it’s the perfect time to explore some of Ontario’s best farms to visit in winter. From maple syrup farms to cozy farm stays, these destinations offer exciting winter farm experiences for all ages.',
      imageUrl: FebruaryMain,
      categoryName: 'Travel',
      author: 'Farmciti',
      publishedAt: '2025-02-07',
      slug: 'the-best-farm-to-visit-in-feb'
    },
    {
      id: '4-ways-to-enjoy-evergreen-brick-works-this-week',
      title: '4 Ways to Enjoy Evergreen Brick Works This Week!',
      excerpt: 'Discover 4 exciting ways to enjoy Evergreen Brick Works this week! Shop local at the indoor Farmers Market, skate under the historic beams, groove at DJ Skate Nights, and explore the Garden Market.',
      imageUrl: MainEvergreen,
      categoryName: 'Experience',
      author: 'Farmciti',
      publishedAt: '2025-02-07',
      slug: '4-ways-to-enjoy-evergreen-brick-works-this-week'
    },
    {
      id: '4-must-visit-farms-near-toronto-before-christmas',
      title: '4 Must-Visit Farms Near Toronto Before Christmas',
      excerpt: 'Get into the holiday spirit with these 4 must-visit farms near Toronto! From festive events to winter activities, discover the best places to celebrate Christmas in the countryside.',
      imageUrl: MainChristmas,
      categoryName: 'Experience',
      author: 'Farmciti',
      publishedAt: '2025-02-07',
      slug: '4-must-visit-farms-near-toronto-before-christmas'
    }

  ];

  // useEffect(() => {
  //   fetchPosts();
  // }, []);

  // const fetchPosts = async () => {
  //   try {
  //     setLoading(true);
      
  //     const response = await fetch(
  //       'https://farmmode.ca/wp-json/wp/v2/posts?per_page=10&_embed'
  //     );
      
  //     if (!response.ok) {
  //       throw new Error(`Failed to fetch posts: ${response.status}`);
  //     }
      
  //     const data = await response.json();
      
  //     const formattedPosts = data.map((post) => ({
  //       id: post.id,
  //       title: post.title?.rendered ?? 'Untitled',
  //       excerpt: post.excerpt?.rendered?.replace(/<[^>]*>/g, '') ?? '',
  //       imageUrl: post._embedded?.['wp:featuredmedia']?.[0]?.source_url || 
  //                 'https://via.placeholder.com/800x600?text=No+Image',
  //       categoryName: post._embedded?.['wp:term']?.[0]?.[0]?.name ?? 'Uncategorized',
  //       author: post._embedded?.author?.[0]?.name ?? 'Farm City',
  //       publishedAt: post.date,
  //       slug: post.slug || `post-${post.id}`,
  //       isExternal: true, 
  //       externalUrl: post.link 
  //     }));
      
  //     setPosts(formattedPosts);
  //   } catch (error) {
  //     console.error('Failed to fetch posts:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const filteredPosts = useMemo(() => {
    // first: localCards, Next: posts
    const sortedPosts = [...posts].sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt));
    let filtered = [...localCards, ...sortedPosts];
    
    if (selectedCategory !== 'all') {
      const filteredLocalCards = localCards.filter(post => 
        post.categoryName?.toLowerCase() === selectedCategory.toLowerCase()
      );
      const filteredPosts = sortedPosts.filter(post => 
        post.categoryName?.toLowerCase() === selectedCategory.toLowerCase()
      );
      filtered = [...filteredLocalCards, ...filteredPosts];
    }
    
    if (search) {
      filtered = filtered.filter(post => 
        post.title.toLowerCase().includes(search.toLowerCase()) ||
        post.excerpt.toLowerCase().includes(search.toLowerCase())
      );
    }
    
    return filtered;
  }, [localCards, posts, selectedCategory, search]);

  // Featured post 
  const featuredPost = filteredPosts[0];
  const regularPosts = filteredPosts.slice(1);

  return (
    <div className={BlogMainStyle["blog-page"]}>

      

      {/* Main Content */}
      <main className={BlogMainStyle["blog-content"]}>
        {loading ? (
          <div className={BlogMainStyle["loading"]}>Loading...</div>
        ) : filteredPosts.length === 0 ? (
          /* Empty State */
          <div className={BlogMainStyle["empty-state"]}>
            <div className={BlogMainStyle["empty-icon"]}>
              <svg width="120" height="120" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <h2 className={BlogMainStyle["empty-title"]}>No posts found</h2>
            <p className={BlogMainStyle["empty-description"]}>
              {selectedCategory !== 'all' 
                ? `We don't have any ${selectedCategory} posts yet. Check back soon or explore other categories!`
                : search
                ? `No posts match your search "${search}". Try different keywords or browse all posts.`
                : "No posts available at the moment. Check back soon!"}
            </p>
            <button 
              className={BlogMainStyle["empty-button"]}
              onClick={() => {
                if (selectedCategory !== 'all' || search) {
                  window.location.href = '/blog';
                }
              }}
            >
              {selectedCategory !== 'all' || search ? 'View All Posts' : 'Go to Homepage'}
            </button>
          </div>
        ) : (
          <>
            {/* Featured Post (Large) */}
            {featuredPost && (
              <section className={BlogMainStyle["featured-section"]}>
                <article className={BlogMainStyle["featured-post"]}>
                  {featuredPost.isExternal ? (
                    <a 
                      href={featuredPost.externalUrl} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className={BlogMainStyle["featured-link"]}
                    >
                      <div className={BlogMainStyle["featured-image"]}>
                        <img src={featuredPost.imageUrl} alt={featuredPost.title} />
                        <div className={BlogMainStyle["featured-overlay"]}>
                          <span className={BlogMainStyle["featured-category"]}>
                            {featuredPost.categoryName}
                          </span>
                          <h2 className={BlogMainStyle["featured-title"]}>
                            {featuredPost.title}
                          </h2>
                          <p className={BlogMainStyle["featured-excerpt"]}>
                            {featuredPost.excerpt}
                          </p>
                          <div className={BlogMainStyle["featured-meta"]}>
                            <span>{featuredPost.author}</span>
                            <span>•</span>
                            <span>
                              {new Date(featuredPost.publishedAt).toLocaleDateString('en-US', {
                                month: 'short',
                                day: 'numeric',
                                year: 'numeric'
                              })}
                            </span>
                          </div>
                        </div>
                      </div>
                    </a>
                  ) : (
                    <Link to={`/blog/${featuredPost.slug}`} className={BlogMainStyle["featured-link"]}>
                      <div className={BlogMainStyle["featured-image"]}>
                        <img src={featuredPost.imageUrl} alt={featuredPost.title} />
                        <div className={BlogMainStyle["featured-overlay"]}>
                          <span className={BlogMainStyle["featured-category"]}>
                            {featuredPost.categoryName}
                          </span>
                          <h2 className={BlogMainStyle["featured-title"]}>
                            {featuredPost.title}
                          </h2>
                          <p className={BlogMainStyle["featured-excerpt"]}>
                            {featuredPost.excerpt}
                          </p>
                          <div className={BlogMainStyle["featured-meta"]}>
                            <span>{featuredPost.author}</span>
                            <span>•</span>
                            <span>
                              {new Date(featuredPost.publishedAt).toLocaleDateString('en-US', {
                                month: 'short',
                                day: 'numeric',
                                year: 'numeric'
                              })}
                            </span>
                          </div>
                        </div>
                      </div>
                    </Link>
                  )}
                </article>
              </section>
            )}

            {/* Regular Posts Grid */}
            <section className={BlogMainStyle["posts-section"]}>
              <h2 className={BlogMainStyle["section-title"]}>Latest Stories</h2>
              <div className={BlogMainStyle["posts-grid"]}>
                {regularPosts.map((post) => (
                  <article key={post.id} className={BlogMainStyle["blog-card"]}>
                    {post.isExternal ? (
                      <a 
                        href={post.externalUrl} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className={BlogMainStyle["card-link"]}
                      >
                        <div className={BlogMainStyle["card-image"]}>
                          <img src={post.imageUrl} alt={post.title} />
                          <span className={BlogMainStyle["card-category"]}>
                            {post.categoryName}
                          </span>
                        </div>
                        <div className={BlogMainStyle["card-content"]}>
                          <h3 className={BlogMainStyle["card-title"]}>{post.title}</h3>
                          <p className={BlogMainStyle["card-excerpt"]}>{post.excerpt}</p>
                          <div className={BlogMainStyle["card-meta"]}>
                            <span className={BlogMainStyle["card-author"]}>{post.author}</span>
                            <span className={BlogMainStyle["card-date"]}>
                              {new Date(post.publishedAt).toLocaleDateString('en-US', {
                                month: 'short',
                                day: 'numeric'
                              })}
                            </span>
                          </div>
                        </div>
                      </a>
                    ) : (
                      <Link to={`/blog/${post.slug}`} className={BlogMainStyle["card-link"]}>
                        <div className={BlogMainStyle["card-image"]}>
                          <img src={post.imageUrl} alt={post.title} />
                          <span className={BlogMainStyle["card-category"]}>
                            {post.categoryName}
                          </span>
                        </div>
                        <div className={BlogMainStyle["card-content"]}>
                          <h3 className={BlogMainStyle["card-title"]}>{post.title}</h3>
                          <p className={BlogMainStyle["card-excerpt"]}>{post.excerpt}</p>
                          <div className={BlogMainStyle["card-meta"]}>
                            <span className={BlogMainStyle["card-author"]}>{post.author}</span>
                            <span className={BlogMainStyle["card-date"]}>
                              {new Date(post.publishedAt).toLocaleDateString('en-US', {
                                month: 'short',
                                day: 'numeric'
                              })}
                            </span>
                          </div>
                        </div>
                      </Link>
                    )}
                  </article>
                ))}
              </div>
            </section>
          </>
        )}
      </main>
    </div>
  );
};

export default BlogPage;
